import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject } from 'rxjs';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  progressBarArray = [];
  selectedItem: any;
  selectTab: string;
  @Input() indexItem: number;
  @Input() progressBarState: string = '';
  @Input() progressBarArray1: any = [];
  constructor(private router: Router, private route: ActivatedRoute, private _data: DataService) {
    this.progressBarArray = [
      { name: "select", src: 'assets/select.png', index: 0 },
      { name: "submit", src: 'assets/submit.png', index: 1 },
      { name: "extract", src: 'assets/extract.png', index: 2 },
      { name: "transform", src: 'assets/transform.png', index: 3, type: "legacyextract" },
      { name: "upload", src: 'assets/active_upload.png', index: 4, type: "cloud" },
      { name: "load", src: 'assets/icon_cloud load.png', index: 5, type: "cloud" }
    ];


  }

  ngOnInit(): void {
    if (this.progressBarArray1 != null) {
      this.progressBarArray = this.progressBarArray1;
    }

  }

  getColor(country) {
    switch (country) {
      case 'select':
        return 'green';
      case 'submit':
        return 'blue';
      case 'extract':
        return 'red';
    }
  }




}
